import axios from 'axios'
import jsonpAdapter from 'axios-jsonp'
import filterAlbums from './filterAlbumsToShow'

// fetch data from gonation and sets it to component state.
export default async (gonationID, displayAlbums) => {
  return await axios({
    url: `https://data.prod.gonation.com/profile/gallery?profile_id=${gonationID}`,
    adapter: jsonpAdapter,
  }).then(res => {
    // checks for albums you want to remove if any else use all albums.
    const albumList = displayAlbums
      ? filterAlbums(res.data, displayAlbums)
      : res.data
    return albumList
    //   setGalleryData({ ...galleryData, albums: albumList, isLoading: false })
  })
}
